import React, { PropsWithChildren } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { API_ACCESS_KEY } from 'constants/common'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import {
  clearSessionTokens,
  get,
  mapOperationsToDispatchProps
} from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  user: UserPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    user: UserOperations
  }
}

type OwnProps = PropsWithChildren

type AppProps = StateProps & DispatchProps & OwnProps
const AuthenticatorFC: React.FC<any> = (props: AppProps) => {
  const { children, user, operations } = props
  const navigate = useNavigate()

  React.useEffect(() => {
    if (localStorage.getItem(API_ACCESS_KEY) === null) {
      operations.user.set({ ...user, authenticated: false })
      navigate('/')
    } else if (localStorage.getItem(API_ACCESS_KEY) !== null && user.id === 0) {
      void get('/account/profile/').then(profileData => {
        if (profileData.length > 0) {
          const userData = {
            ...profileData[0],
            authenticated: true
          }
          operations.user.set(userData)
        } else {
          clearSessionTokens()
          operations.user.set({ ...user, authenticated: false })
          navigate('/')
        }
      })
    }
  }, [])
  return <>{children}</>
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    user: state.user
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  user: userOperations
})

const Authenticator = connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthenticatorFC) as React.FC<OwnProps>

export default Authenticator
